import { render } from "./refund-list.vue?vue&type=template&id=58aa12d1&scoped=true"
import script from "./refund-list.vue?vue&type=script&lang=js"
export * from "./refund-list.vue?vue&type=script&lang=js"

import "./refund-list.vue?vue&type=style&index=0&id=58aa12d1&scoped=true&lang=less"

import exportComponent from "/home/www/jenkins/jenkins_home/workspace/yizhige_production/yizhige_admin_pro/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-58aa12d1"]])

export default __exports__